import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { initTracing } from "@smartsuite/tracing";

initTracing(
  {
    tracingEnabled: !!SENTRY_ENVIRONMENT,
    sentryDSN:
      "https://c48d75d55c038a76feebacf58c346541@o1324044.ingest.us.sentry.io/4508499497254912",
    envName: SENTRY_ENVIRONMENT,
    tracingRelease: `${SENTRY_ENVIRONMENT}@${APP_VERSION}-${CI_COMMIT_SHORT_SHA}`,
    sentryProfilingEnabled: true,
    sentryReplayEnabled: import.meta.env.PROD,
    sentryTracesSampleRate: import.meta.env.PROD ? 0.5 : 1.0,
    sentryReplaysOnErrorSampleRate: 1.0,
    sentryReplaysSessionSampleRate: 0.1,
  },
  "page-designer",
);

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <App />,
);
